export default 'M17.45 0 3.5 14h6.586L6.55 24 20.5 10h-6.586z';